<template>
    <section class="section bg-dark">

        <Header :menu="menus" :links="social_networks" :langs="langs" />

        <!-- <main class="crsl"> -->
            <Carousel :items="banners" />
        <!-- </main> -->
    </section>

    <section class="section bg-light2 py-5" id="work">
        <main class="my-5">
            <div class="h1 my-5">{{ TR.projects }}</div>

            <div class="container">
                <Pagination
                    v-if="videos.length"
                    :row_count="totalrecords"
                    :pages_count="pages_count"
                    :lang="TR"
                    :current_page="current_page"
                    :perpage="perpage"
                    :page_row_count="G.rowsPerPageOptions"
                    @navigate="pagenav"
                    class="pagenav mb-5"
                />
            </div>

            <div class="row row-cols-1 row-cols-sm-5 g-4 mb-3">
                <div class="col card-block py-4" v-for="(item, index) in videos" :key="index">

                    <a class="card work-card text-decoration-none text-dark" :href="item.link" target="_blank">
                        <img :src="item.image || item.youtube_image" class="card-img-top da-card-img-top" :alt="item.translate[0]?.title" />
                        <p class="card-title text-secondary small mt-4">{{ G.dateToStr(item.video_date, 'news_date', 'date') }}</p>
                        <div class="card-body p-0">
                            <h5 class="card-title mb-3">{{item.translate[0].title}}</h5>
                            <p class="card-text" v-html="item.translate[0].description"></p>
                        </div>
                    </a>

                </div>
                <!-- <div class="col card-block py-4" v-for="(item, index) in data.work" :key="index">

                    <a class="card work-card text-decoration-none text-dark" :href="item.link" target="_blank">
                        <img :src="item.image" class="card-img-top" :alt="item.title" />
                        <p class="card-title text-warning mt-4">{{item.date}}</p>
                        <div class="card-body p-0">
                            <h5 class="card-title mb-3">{{item.title}}</h5>
                            <p class="card-text" v-html="item.description"></p>
                        </div>
                    </a>

                </div> -->
            </div>

            <div class="container">
                <Pagination
                    v-if="videos.length"
                    :row_count="totalrecords"
                    :pages_count="pages_count"
                    :lang="TR"
                    :current_page="current_page"
                    :perpage="perpage"
                    :page_row_count="G.rowsPerPageOptions"
                    @navigate="pagenav"
                    class="pagenav mt-5"
                />
            </div>

        </main>
    </section>

    <section class="bg-dark py-5" id="about">
        <main class="py-5">
            <Profile :data="bio" />
        </main>
    </section>

    <section class="bg-light2" id="contact">
        <Footer :data="social_networks" :lang="TR" />
    </section>

</template>


<script>
    import { onMounted, ref, watchEffect } from "vue";
    import { useRoute } from "vue-router";
    import { useStore } from "@/system_modules/store";

    import Header from "@/pages/components/Header.vue";
    import Carousel from "@/pages/components/Carousel.vue";
    import Profile from "@/pages/components/Profile";
    import Footer from "@/pages/components/Footer";

    import Pagination from '@/components/elements/Pagination.vue';

    import { bio } from "@/data/data";
    import { G, ajax } from "@/_common";

    export default {
        name: "HomeP",
        props:{
            data:{
                type: Object,
                default: () => {}
            }
        },
        components: {
            Header,
            Carousel,
            Profile,
            Footer,
            Pagination,
        },
        setup() {
            const store = useStore();
            const route = useRoute();
            // const router = useRouter();
            const videos = ref([]);
            const banners = ref([]);
            const langs = ref([]);
            const menus = ref([]);
            const social_networks = ref([]);

            const TR = ref({});

            const route_obj = ref({});
            const pages_count = ref(0);
            const current_page = ref(null);
            const perpage = ref(G.rowsPerPage);
            const totalrecords = ref(0);

            const page = route.params && route.params.page ? parseInt(route.params.page) : 1;
            perpage.value = route.params && route.params.perpage ? parseInt(route.params.perpage) : G.rowsPerPage;

            current_page.value = page;

            const pagenav = async (p, pp) => {
                perpage.value = pp;
                current_page.value = p;

                await getVideos(p);

                // router.push({ name: 'videos_paging', params: route_obj.value });
            }

            const getVideos = async (first) => {
                route_obj.value = {
                    page: first,
                    perpage: perpage.value,
                };

                await ajax({
                    loading: true,
                    url: store.getVideosPaging(route_obj.value), // + `?rows=${perpage.value}&first=${(first-1)*perpage.value}&search_text=${encodeURIComponent(search_text.value)}`,
                    success: (e) => {
                        videos.value = e.data.data; //.filter(f => f.main_status != 1 );
                        totalrecords.value = e.data.total_records;
                        pages_count.value = Math.ceil(totalrecords.value / perpage.value);
                    }
                });
            };

            watchEffect(() => {
                TR.value = store.getTranslation();
            });

            onMounted(async () => {

                await getVideos(page);

                // await ajax({
                //     url: store.getVideos(),
                //     success: async (e) => {
                //         videos.value = e.data.data;
                //     },
                // });

                await ajax({
                    url: store.getLangs(),
                    success: (e) => {
                        langs.value = e.data;
                    }
                });

                await ajax({
                    url: store.getMenus(),
                    success: (e) => {
                        menus.value = e.data;
                    }
                });

                await ajax({
                    url: store.getBanners(),
                    success: async (e) => {
                        banners.value = e.data;
                    },
                });

                await ajax({
                    url: store.getSocialNetwork(),
                    success: async (e) => {
                        social_networks.value = e.data;
                    },
                });
            });

            return {
                G,
                TR,
                pagenav,
                perpage,
                current_page,
                pages_count,
                totalrecords,

                langs,
                menus,
                videos,
                banners,
                bio,
                social_networks,
            };
        },
    };
</script>


<style lang="scss">
    main {
        margin: 0px 140px;
    }

    .section {
        // height: 100vh;
        min-height: 100vh;
    }

    .crsl{
        // padding-top: 100px;
        width: 100%;
    }

    .slick-slide .news-name a {
        font-size: 25px;
        font-weight: 700;
        text-transform: uppercase;
        margin-bottom: 20px;
        color: black;
        text-decoration: none;
    }
    .card-block:hover{
        background-color: #e5e5e5;
        scale: 1.02;
    }
    .card:hover {
        box-shadow: unset;
        scale: unset;
    }
    .da-card-img-top{
        height: 220px;
        object-fit: cover;
    }
    .work-card{
        // height: 450px;
        background-color: transparent;
        border: 0;
    }

    @media (max-width: 576px) {
        main {
            margin: unset;
        }
        .section {
            min-height: unset;
        }
    }
</style>
